import { EventLabels } from "@/app/constants/mix-panel-enums";
import {
  Config,
  DataStorageType,
  HeaderContentAlignment,
  LoginFlow,
  MembershipsFlow,
} from "@thriwe-2-0/thriwe-ui-utils";
import AppRoutes from "../../../constants/routes";

import { BsQuestionCircle } from "react-icons/bs";
import { FaFacebook, FaWhatsapp } from "react-icons/fa";
import { FiHelpCircle, FiMail, FiSettings } from "react-icons/fi";
import {
  HiOutlineLocationMarker,
  HiOutlinePhone,
  HiOutlineUser,
} from "react-icons/hi";
import { IoLogoYoutube } from "react-icons/io";
import { IoNotificationsOutline } from "react-icons/io5";
import { LuWallet } from "react-icons/lu";
import { PiUserCircleFill } from "react-icons/pi";
import { RiUserLine } from "react-icons/ri";
import { RxLinkedinLogo } from "react-icons/rx";
import { TbLogout2 } from "react-icons/tb";

const marketPlaceConfig: Config = {
  designVersion: "v2",
  toastVersion: "v2",
  enableBookmarks: true,
  membershipFlow: MembershipsFlow.DEFAULT,
  withoutDialogLogin: false,
  enableLanguageSwitch: false,
  limitMaxSessions: true,
  isShowPleaseNoteModal: false,
  nativeDataSavingType: DataStorageType.SESSION_STORAGE,
  flagsForLibraryJourney: {
    GOLF_BOOKING: {
      hideGuestPayment: false,
      showGuestDisclaimer: false,
      showZeroPaymentForRefundable: false,
      hideRefundableText: false,
    },
    // AIRPORT_TRANSFER_BOOKING: {
    //   hideGuestPayment: true,
    //   showGuestDisclaimer: true,
    //   showZeroPaymentForRefundable: true,
    //   hideRefundableText: true,
    // },

    MEET_AND_GREET_BOOKING: {
      hideGuestPayment: false,
      showGuestDisclaimer: false,
      showZeroPaymentForRefundable: false,
      hideRefundableText: false,
      showRefundableDisclaimer: false,
      // form1Icon: "./assets/meetngreet-hands-scb.png",
      hidePackageDetailsPage: false,
      showTicketUrl: true,
      showTravelType: false,
      isTncAvailable: true,
      showAddOnService: false,
      hideTotalPayableInMobileFooter: false,
      showBookmarkNextTobackBtn: true,
    },

    // GOLF_LEARN_BOOKING: {
    //   hideGuestPayment: true,
    //   showGuestDisclaimer: true,
    //   showZeroPaymentForRefundable: true,
    //   hideRefundableText: true,
    // },

    // STATIC_COUPON: {
    //   hideGuestPayment: true,
    //   showGuestDisclaimer: true,
    //   showZeroPaymentForRefundable: true,
    //   hideRefundableText: true,
    // },
    // UNIQUE_COUPON: {
    //   hideGuestPayment: true,
    //   showGuestDisclaimer: true,
    //   showZeroPaymentForRefundable: true,
    //   hideRefundableText: true,
    // },
    // DELAYED: {
    //   hideGuestPayment: true,
    //   showGuestDisclaimer: true,
    //   showZeroPaymentForRefundable: true,
    //   hideRefundableText: true,
    // },
  },
  dropDownPopupMenu: [
    {
      path: AppRoutes.profileInfo,
      name: "Profile",
      icon: "profile-popup.svg",
      ReactIcon: RiUserLine,
    },
    {
      path: AppRoutes.faq,
      icon: "faq-popup.svg",
      name: "FAQs",
      ReactIcon: BsQuestionCircle,
    },
    {
      path: AppRoutes.support,
      icon: "support-popup.svg",
      name: "Support",
      ReactIcon: HiOutlinePhone,
    },
    {
      path: "/",
      name: "Logout",
      icon: "logout-popup.svg",
      isLogout: true,
      ReactIcon: TbLogout2,
    },
  ],
  routes: {
    routesWithLogin: [
      {
        path: AppRoutes.linkMembership,
        name: "Add Membership",
        iconPath: "/menu/FAQ.svg",
      },
      {
        path: "",
        name: "Categories",
        isCategoryPopup: true,
      },
      {
        path: AppRoutes.history,
        name: "History",
        iconPath: "/menu/Redemption.svg",
      },

      {
        path: AppRoutes.faq,
        name: "FAQ's",
        iconPath: "/menu/T&C.svg",
      },
    ],
    routesWithoutLogin: [],
  },

  restrictedRoutes: [],

  landing: {
    heroSection: {
      heading: `Thriwe Nexus: `,
      subHeading: `One Platform. Multiple Possibilities.`,
      content: `Create a personalized loyalty platform with a vast rewards catalog from over 10,000 brands to build lasting relationships with your stakeholders.`,
      isShowPrimaryCTA: true,
      primaryCTAText: `Explore More`,
      isShowAppLinks: true,
    },
  },

  linkMembershipConfig: {
    isShowLinkMembershipOption: true,
    isShowAddCardOption: true,
    binConfiguration: {
      cardNumberDigits: 8,
      isAllowedBothCardNumbers: true,
    },
  },

  dashboard: {
    version: "LISTING",
    marketplaceBanner: true,
    restrictToSingleCategory: true,
    marketplaceBannerCustom: false,
    bannerWithBgImage: false,
    banner: {
      heading: `Unlock a world of exclusive benefits with Thriwe!`,
      subHeading: ``,
    },
    isShowMembershipsSection: true,
    isShowPreviousBookingSection: true,
    isShowSavingCard: true,
    isShowQuotaSummary: true,
    isShowBenefitFeedback: true,
    isCarousel: false,
    isSwitchPill: false,
  },

  history: {
    isShowGetHelpCTA: false,
    isShowBookingFeedback: true,
  },

  settings: {
    isShowChangeCurrencyOption: true,
    isShowManageDevices: true,
    enablingOptions: [
      {
        label: "Email",
        key: "emailNotification",
        icon: "email-support.png",
        ReactIcon: FiMail,
      },
      {
        label: "SMS",
        key: "mobileNotification",
        icon: "message.png",
        ReactIcon: HiOutlineLocationMarker,
      },
      {
        label: "Whatsapp",
        key: "whatsappNotification",
        icon: "whatsapp.png",
        ReactIcon: FaWhatsapp,
      },
      {
        label: "Push Notification",
        key: "appNotification",
        icon: "bell.png",
        ReactIcon: IoNotificationsOutline,
      },
    ],
  },

  supports: {
    isShowAboutUs: true,
    isShowTnC: true,
    isShowPrivacyPolicy: true,
    isShowFaqs: true,
    isShowHotline: true,
    isShowWriteToUs: true,
    isShowFeedbackAndQuery: false,
    hotlineDataArr: [
      {
        value: "1800 208 7899",
        label: "Toll Free Number (India)",
        labelTKey: "tollFreeIndia",
        href: "tel:",
        image: "phone.png",
        cta: EventLabels.CTA_Call,
      },
      {
        value: "8000 3570 3553",
        label: "Toll Free Number (UAE)",
        labelTKey: "tollFreeUAE",
        href: "tel:",
        image: "phone.png",
        cta: EventLabels.CTA_Call,
      },
      {
        value: "+91 9717176899",
        label: "Whatsapp Number",
        labelTKey: "whatsapp",
        href: "tel:",
        image: "whatsapp.png",
        cta: EventLabels.CTA_Whatsapp_Message,
      },
      {
        value: "Mon to Fri- 9 AM to 7 PM",
        label: "Working hours",
        labelTKey: "workingHours",
        href: null,
        image: "working-hours.png",
      },
      {
        value: "customer.care@thriwe.com",
        label: "Email",
        labelTKey: "email",
        href: "mailto:",
        image: "email-support.png",
        cta: EventLabels.CTA_Email,
      },
    ],
  },

  yourCardsList: {
    isShowAddBtn: false,
    btnText: ``,
  },

  profile: {
    showSideBarMenu: true,
    showProfilePicture: true,
    isDisplayLogout: true,
    isDisplayDeleteMyAccount: true,
    profileComponents: [
      {
        name: "Account",
        route: "account",
        icon: "account",
        ReactIcon: PiUserCircleFill,
      },
      {
        name: "Profile",
        route: "profile-info",
        icon: "profile",
        ReactIcon: HiOutlineUser,
      },
      {
        name: "Savings",
        route: "savings",
        icon: "saving",
        ReactIcon: LuWallet,
      },
      {
        name: "Settings",
        route: "settings",
        icon: "settings",
        ReactIcon: FiSettings,
      },
      {
        name: "Support",
        route: "support",
        icon: "support",
        ReactIcon: FiHelpCircle,
      },
    ],
    // accountInfo: { showMemberships: true, showCards: true },
    profile: {
      editProfile: true,
      isShowAddress: false,
      editableData: [
        {
          name: "First Name",
          editable: true,
          type: "text",
          labelName: "First Name",
          variableName: "firstName",
        },
        {
          name: "Last Name",
          editable: true,
          type: "text",
          labelName: "Last Name",
          variableName: "lastName",
        },
        {
          name: "Email",
          editable: true,
          type: "text",
          labelName: "Email",
          variableName: "email",
        },
        {
          name: "Mobile Number",
          variableName: "mobileNumber",
          editable: true,
          type: "number",
          labelName: "Phone Number",
        },
        {
          name: "Gender",
          editable: true,
          type: "select",
          labelName: "Gender",
          variableName: "gender",
        },
        {
          name: "Date of Birth",
          editable: true,
          type: "calendar",
          labelName: "Date of Birth",
          variableName: "dob",
        },
      ],
    },

    // bookmarks: true,
    // savings: true,
    // settings: true,
    // support: true,
    // logoutButton: true,
  },
  login: {
    loginFlow: LoginFlow.LOGIN_WITH_MOBILE_EMAIL_OTP,
    checkUserBeforeLogin: false,
    otpConfig: {
      otpLength: 4,
      resendOtpTimer: 30,
      inputType: "number",
      resendOtp: {
        onSms: true,
        onWhatsapp: true,
        isShowBothOptions: false,
      },
    },
    // userRegistration: {},
    heading: { showLogo: true },
    name: "login",
    subheading: "New User?",
    signUpText: "Create an account",
    fields: {
      mobile: {
        cronName: "mobile",
        label: "Phone Number",
        type: "number",
        validationRegex: /^\d{7,12}$/i,
        validationText: "Please enter a valid phone number",
      },
      email: {
        cronName: "email",
        label: "Email Address",
        type: "text",
        validationRegex:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        validationText: "Please enter a valid email address",
      },
    },
    captcha: false,
    termAndConditionCheckbox: true,
    showauth: true,
    authType: [
      {
        type: "google",
        logo: "login-media-1",
      },
      {
        type: "facebook",
        logo: "login-media-2",
      },
      {
        type: "apple",
        logo: "login-media-3",
      },
    ],
    // authType: ["google", "facebook", "apple"],
  },

  userRegistration: {
    preLoginUserRegistrationForm: true,
    requiresMembershipLinkBeforeDashboard: true,
  },

  // signup: {
  //   signupFlow: SignupFlow.SIGNUP_WITHOUT_PREAUTH,
  //   preauth: {
  //     show: false,
  //     title: "Verify Your email address",
  //     description:
  //       "Verify your email address We have sent an email to rahul.kar5432ern@thriwe.com Follow the instructions in the email to complete your registration. After registration, log in and complete the steps from here: https://stag-visaone.thriwe.com/”.",
  //     buttonName: "",
  //   },

  //   subheading: "Already have an account?",
  //   signUpText: "Create an account",
  //   fields: {
  //     firstName: {
  //       label: "Full Name",
  //       placeHolderText: "",
  //       validationRegex: /^/,
  //       validationText: "",
  //     },
  //     email: {
  //       label: "Email Id",
  //       placeHolderText: "",
  //       validationRegex: /^/,
  //       validationText: "",
  //       requiredValidationText: "",
  //     },
  //     mobile: {
  //       label: "Phone Number",
  //       placeHolderText: "Enter Phone Number",
  //       validationRegex: /^/,
  //       validationText: "",
  //       requiredValidationText: "",
  //     },
  //     otp: {
  //       label: "OTP",
  //       validationRegex: /^/,
  //       validationText: "",
  //       requiredValidationText: "",
  //     },
  //   },
  //   button: {
  //     for: "formSubmit",
  //     text: "Continue",
  //   },
  //   loginText: "Sign In",
  //   showLabel: true,
  //   captcha: false,
  // },
  bookingTerms: [
    {
      string:
        "I have read and accept the Terms and Conditions and Redemption Process",
      optional: false,
    },
  ],
  clubBookingTerms: [
    {
      string: `By submitting this request I admit that I have read and understood the Thriwe and Ladies Club Program Terms & Conditions`,
      optional: false,
    },
    {
      string: `This benefit is only for female self-credit cardholder, where male is not eligible to use this benefit.`,
      optional: false,
    },
  ],

  redeemCoupon: {
    tooltip: "some tooltip",
    showUpgradeModal: false,
    confirmButtonText: "Go To",
    redirectOnConfirm: true,
  },

  header: {
    contentAlign: HeaderContentAlignment.Left,
    searchBar: true,
    //searchPlaceholderText: `Search for Brands and More`,
    isShowDefaultCompaignSection: true,
    // searchDropdownDefaultCompaignSectionHeading: `POPULAR OFFERS`,
    searchOnBehalfOn: `BENEFIT`, // BENEFIT , BRAND, OUTLET
    // searchBarAllowedRoutes: [AppRoutes.dashboard, AppRoutes.dashboardListing],
    addMembership: true,
    isShowConciergeModal: false,
    membershipPopup: {
      isShowAddMembershipButton: true,
      membershipCardDisplayName: `MEMBERSHIP_ID`, // CARD_NUMBER  MEMBERSHIP_ID
    },
  },
  footer: {
    excludedRoutes: [
      AppRoutes.login,
      AppRoutes.register,
      AppRoutes.forgotPassword,
      AppRoutes.registerUserDetails,
      AppRoutes.loginLinkMembership,
    ],
    hiddenOnDesktopRoutes: [],
    hiddenOnMobileRoutes: [],
    showDownloadAppLink: true,
    isShowCustomFooter: false,
    isShowCopyRightTextInCenter: false,
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.thriwe.mainapp&hl=en_IN",
    appStoreUrl: "https://apps.apple.com/in/app/thriwe/id1529613327",
    socialMedia: [
      {
        image: "logo-facebook.png",
        redirectUrl: "https://www.facebook.com/thriwegroup/",
      },
      {
        image: "logo-linkedin.png",
        redirectUrl:
          "https://www.linkedin.com/company/thriwe/?originalSubdomain=in",
      },
      {
        image: "logo-youtube.png",
        redirectUrl: "https://www.youtube.com/watch?v=ZMLExgWvuHI&t=1s",
      },
    ],

    socialMedias: [
      {
        ReactIcon: FaFacebook,
        redirectUrl: "https://www.facebook.com/thriwegroup/",
        defaultColor: "#1d1d1f",
        hoveredColor: "#1877F2",
        size: 18,
      },
      {
        ReactIcon: RxLinkedinLogo,
        redirectUrl:
          "https://www.linkedin.com/company/thriwe/?originalSubdomain=in",
        defaultColor: "#1d1d1f",
        hoveredColor: "#0A66C2",
        size: 18,
      },
      {
        ReactIcon: IoLogoYoutube,
        redirectUrl: "https://www.youtube.com/watch?v=ZMLExgWvuHI&t=1s",
        defaultColor: "#1d1d1f",
        hoveredColor: "#FF0000",
        size: 18,
      },
    ],

    footerLink2: [
      {
        name: "Terms & Conditions",
        routeLink: AppRoutes.termAndCondition,
      },
      {
        name: "Privacy Policy",
        routeLink: AppRoutes.privacyAndPolicy,
      },
    ],
    bottomLinks: [
      {
        category: "Company",
        link: [
          {
            name: "About us",
            routeLink: AppRoutes.about,
          },
          {
            name: "Support",
            routeLink: AppRoutes.support,
            onLogin: true,
          },
        ],
      },
      {
        category: "Overview",
        link: [
          {
            name: "Features",
            routeLink: AppRoutes.features,
          },
          {
            name: "FAQs",
            routeLink: AppRoutes.faq,
          },
        ],
      },
      {
        category: "Quick Links",
        link: [
          {
            name: "Terms & Conditions",
            routeLink: AppRoutes.termAndCondition,
          },
          {
            name: "Privacy Policy",
            routeLink: AppRoutes.privacyAndPolicy,
          },
          {
            name: "Refund Policy",
            routeLink: AppRoutes.refundPolicy,
          },
        ],
      },
    ],
  },
  preLoginCustomHeader: {
    isShowBackButton: true,
    isShowHelpButton: false,
    isShowCustomHeader: true,
  },
  airportTransfer: {
    isCarSelectionAllowed: true,
  },
  QuotaSummaryModal: {
    show: false,
    showMonthlyRespectiveQuota: false,
    showYearlyAvailableQuota: false,
    showMonthlyAvailableQuota: false,
    combineConfigsQuota: false,
  },
  listingDetails: {
    showCTA: false,
  },
};

export default marketPlaceConfig;
